var _style, _circle, _g, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaxg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E5CB22;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{mask:url(#mask_1_);}\n\t.st4{fill:#FFFFFF;stroke:#E5CB22;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 18.6,
    y: 43.6,
    width: 88.5,
    height: 199.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 18.6,
    y: 43.6,
    width: 88.5,
    height: 199.7,
    id: "mask_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2_1_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_1_",
    className: "st2",
    points: "19.3,44.1 105.9,44.1 105.9,242.6 19.3,242.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st4",
    d: "M92,58.7c5-5.7,9.6-10.5,13.9-14.5c-73.6-2.4-52.2,50.9-76.3,104.9c-27.6,62.3,3.3,86,49.3,93.5 c-6.4-7.7-11.7-16.2-15.6-25.4C33.6,179.6,45.6,111.1,92,58.7"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st4",
    d: "M269.2,125.1c-8.7,22.8-21.3,43.8-37.2,62.3c-12.8,15.5-28,28.7-45.2,39.1 c-19.9,12.6-43.1,19.2-66.7,18.9c-13.8,0.1-27.5-0.8-41.1-2.9c7.6,9,16.9,16.4,27.5,21.6c66.6,32.2,70.8-27.6,141.2-57.9 C287.3,189.1,287.4,155.8,269.2,125.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st4",
    d: "M186.8,62.9c9.6,1.7,18.9,5,27.5,9.7c22.4,12.6,41.3,30.6,54.9,52.4c12-33.8,6.4-60.3-19.8-65.1 c-28.9-5.3-51.4-7-73.1-22.1c-26.7-18.5-50.1-12.5-70.4,6.4l4.4,0.2c28.1,1.7,55,7.3,76.3,18.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "st4",
    d: "M92,58.7c-46.3,52.4-58.4,120.9-28.5,158.4c-14-33-11.6-70.8,6.4-101.8 c25.1-41.9,75.5-60,116.9-52.4c-21.4-11.3-48.3-16.8-76.3-18.5l-4.4-0.2C101.6,48.4,97,53,92,58.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "st4",
    d: "M214.3,72.6c-8.6-4.7-17.8-8-27.5-9.7c28.2,14.8,46.9,40,46.9,79.7c-0.3,34.1-18,65.7-46.9,83.8 c17.2-10.4,32.4-23.6,45.2-39.1c15.9-18.4,28.5-39.5,37.2-62.3C255.6,103.3,236.7,85.2,214.3,72.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "st4",
    d: "M186.8,62.9C145.4,55.3,95,73.5,69.9,115.2c-18.1,31.1-20.5,68.9-6.4,102 c3.9,9.2,9.1,17.8,15.6,25.4c13.6,2,27.4,3,41.1,2.9c23.6,0.3,46.7-6.3,66.7-18.9c28.9-18.1,46.6-49.7,46.9-83.8 C233.7,102.9,215,77.8,186.8,62.9 M182.1,207.6c-31.9,20.5-74.3,11.3-94.9-20.4c-20.6-31.7-10.4-72.7,20.5-94.5 c34.5-24.5,78.8-14.9,94.9,20.4C218.4,147.5,214,187.2,182.1,207.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaxg);
export default __webpack_public_path__ + "static/media/PAXG.9d5e5d21669c93f16a54703b086f1751.svg";
export { ForwardRef as ReactComponent };